<div class="card">
  <div class="flex align-items-center justify-content-between mb-4">
    <div class="flex align-items-center">
      <p-button icon="pi pi-arrow-left" styleClass="p-button-text p-button-secondary mr-2" (onClick)="voltar()"></p-button>
      <app-header
        titulo="Registros de Visualização"
        descricao="Lista de registros transformados e prontos para consulta.">
      </app-header>
    </div>
    <div class="flex gap-2">
      <p-splitButton label="Exportar" icon="pi pi-download" [model]="itemsExportar" severity="info"></p-splitButton>
      <p-button icon="pi pi-refresh" (onClick)="carregarRegistros()" [loading]="loading"></p-button>
    </div>
  </div>

  <!-- Painel de Filtros -->
  <p-panel header="Filtros Avançados" [toggleable]="true" [collapsed]="true" styleClass="mb-4">
    <div class="grid p-fluid">
      <div class="col-12 md:col-3">
        <label for="status">Status</label>
        <p-dropdown id="status" [options]="opcoesStatus" [(ngModel)]="statusSelecionado" appendTo="body"></p-dropdown>
      </div>
      <div class="col-12 md:col-3">
        <label for="dataInicio">Data Início</label>
        <p-calendar id="dataInicio" [(ngModel)]="dataInicio" [showIcon]="true" dateFormat="dd/mm/yy"></p-calendar>
      </div>
      <div class="col-12 md:col-3">
        <label for="dataFim">Data Fim</label>
        <p-calendar id="dataFim" [(ngModel)]="dataFim" [showIcon]="true" dateFormat="dd/mm/yy"></p-calendar>
      </div>
      <div class="col-12 md:col-3">
        <label for="busca">Buscar nos Dados</label>
        <input pInputText id="busca" [(ngModel)]="busca" placeholder="Digite para pesquisar..." />
      </div>
      <div class="col-12 flex justify-content-end gap-2 mt-2">
        <p-button label="Limpar" icon="pi pi-filter-slash" severity="secondary" (onClick)="limparFiltros()"></p-button>
        <p-button label="Aplicar Filtros" icon="pi pi-search" (onClick)="aplicarFiltros()"></p-button>
      </div>
    </div>
  </p-panel>

  <p-table 
    [value]="registros" 
    [lazy]="true" 
    (onLazyLoad)="carregarRegistros($event)" 
    [paginator]="true" 
    [rows]="20" 
    [totalRecords]="totalRecords" 
    [loading]="loading"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [rowsPerPageOptions]="[10, 20, 50, 100]">
    
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 80px">ID</th>
        <th style="width: 150px">Status</th>
        <th *ngFor="let col of colunas">{{ col }}</th>
        <th>Mensagem</th>
        <th>Criado Em</th>
        <th style="width: 100px" class="text-center">Ações</th>
      </tr>
    </ng-template>
    
    <ng-template pTemplate="body" let-reg>
      <tr>
        <td><strong>{{ reg.id }}</strong></td>
        <td>
          <app-status-badge [status]="reg.statusIntegracao"></app-status-badge>
        </td>
        <td *ngFor="let col of colunas">
          <div class="text-overflow-ellipsis overflow-hidden white-space-nowrap" [pTooltip]="reg.dados[col]" tooltipPosition="top">
            {{ reg.dados[col] }}
          </div>
        </td>
        <td>{{ reg.mensagem }}</td>
        <td>{{ reg.criadoEm | date:'dd/MM/yyyy HH:mm:ss' }}</td>
        <td class="text-center">
          <p-button icon="pi pi-search" styleClass="p-button-rounded p-button-text" pTooltip="Ver Detalhes" tooltipPosition="top" (onClick)="verDetalhes(reg.id)"></p-button>
        </td>
      </tr>
    </ng-template>
    
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="colunas.length + 4" class="text-center p-4">Nenhum registro de visualização encontrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
